import { useNavigate } from "react-router-dom"
import { useTextStorage } from "../../hooks"
import "./GalleryPage.scss"
import { Button, ButtonSize } from "../../components/Button"
import { ReactPhotoCollage } from "react-photo-collage"
import { useMediaQuery } from "@mui/material"
import { useEffect, useRef } from "react"

// Dynamically import all images from gallery folder
const galleryImages = import.meta.glob<{ default: string }>(
  "../../assets/images/gallery/*.jpg",
  { eager: true },
)

// Convert to array of photo objects for ReactPhotoCollage
const photos = Object.values(galleryImages).map((module) => ({
  source: module.default,
}))

export const GalleryPage: React.FC = () => {
  const collageRef = useRef<HTMLDivElement>(null)

  const { ts } = useTextStorage()
  const navigate = useNavigate()

  const handleButtonClick = () => {
    navigate("/#connect")
  }

  useEffect(() => {
    if (!collageRef.current) return

    const modifyTarget = () => {
      const targetDiv = collageRef.current?.querySelector(
        "div > div > div > div > div > div > div > div",
      ) as HTMLDivElement | null
      if (targetDiv) {
        targetDiv.innerHTML = "További képek"
        targetDiv.style.fontSize = "2rem"
        targetDiv.style.textWrap = "nowrap"
        targetDiv.classList.add("no-before")
        return true
      }
      return false
    }

    // Try immediately
    if (modifyTarget()) return

    // If not found, watch for DOM changes
    const observer = new MutationObserver(() => {
      if (modifyTarget()) {
        observer.disconnect()
      }
    })

    observer.observe(collageRef.current, {
      childList: true,
      subtree: true,
    })

    return () => observer.disconnect()
  }, [])

  const isMobile = useMediaQuery("(max-width: 900px)")

  const setting = {
    width: "100%",
    height: ["200px", "170px"],
    layout: isMobile
      ? [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
      : [4, 3, 4, 3, 4, 3, 4, 3, 3, 3, 4, 3],
    photos: photos,
    showNumOfRemainingPhotos: true,
  }

  return (
    <div className="gallery-page-outer-shell" ref={collageRef}>
      <h3>{ts.pages.gallery.title}</h3>
      <ReactPhotoCollage {...setting} />
      <Button
        text={ts.pages.gallery.buttonText}
        size={ButtonSize.SM}
        onClick={handleButtonClick}
      />
    </div>
  )
}
